export default {
  ADD_REDIRECTS (state, redirects) {
    state.redirects = redirects
  },
  ADD_REDIRECT_SCHEMA (state, redirectSchema) {
    state.redirects.unshift(redirectSchema)
  },
  ADD_NEW_REDIRECT (state, newRedirect) {
    const redirect = state.redirects.find(r => r.tempId === newRedirect.tempId)
    redirect.isNew = false
    redirect.fromUrl = newRedirect.fromUrl
    redirect.toUrl = newRedirect.toUrl
    redirect.id = newRedirect.id
  },
  DELETE_REDIRECT (state, redirectId) {
    state.redirects = state.redirects.filter(r => r.id !== redirectId)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/redirects.js